import axios from 'axios';
import {isDevel} from "./utils";
axios.defaults.withCredentials = true;


const instance = axios.create({
	baseURL: isDevel() ? 'https://www.a2pogo.com' : 'https://www.a2pogo.com'
});

export default instance;